import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-sm text-foreground-500">
      <Link to="/" className="transition-colors hover:text-primary-600">
        首页
      </Link>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-foreground-300" />
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-primary-600">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}